module.exports = __webpack_public_path__ + "img/rotten-tomato-90+.c4da100c.png";